/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_user = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	this.onready = function() {

		/*
		Listener
		*/
		$(document).on('click','.js-user-submit',function() {
			specific_user.save();
		});

		$(document).on('click','.js-user-newpassword-submit',function() {
			specific_user.password();
		});

		$(document).on('click','.js-user-delete-submit',function() {
			specific_user.delete();
		});
	
	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************

	/*
	Save *************************
	Save *************************
	Save *************************
	Save *************************
	*/
	this.save = function(
	) {

		var _user_id 				= $('.js-user-id').val();
		var _user_username       	= $('.js-user-username').val();
		var _user_firstname       	= $('.js-user-firstname').val();
        var _user_lastname        	= $('.js-user-lastname').val();
       	var _user_category      	= $('.js-user-category').val();
        var _user_emailaddress    	= $('.js-user-emailaddress').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/user-action',
			type: "POST",
			data: {
				user_id 			: _user_id,
				user_username 		: _user_username,
				user_firstname 		: _user_firstname,
				user_lastname		: _user_lastname,
				user_category		: _user_category,
				user_emailaddress 	: _user_emailaddress,
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Notifier
			*/
			if(_user_id == 'new') {
				notifier.show(
					'Gebruiker toegevoegd'
				);
			} else {
				notifier.show(
					'Gebruiker aangepast'
				);
			}

			/*
			Close popup
			*/
			popup.close();

			/*
			Refresh
			*/
			window.location.reload();

		})
		.always(function() {
		});

	};

	/*
	Delete *************************
	Delete *************************
	Delete *************************
	Delete *************************
	*/
	this.delete = function(
	) {

		var _user_id 				= $('.js-user-id').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/user-delete',
			type: "POST",
			data: {
				user_id 			: _user_id,
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Notification
			*/
			notifier.show(
				'Gebruiker verwijderd'
			);

			/*
			Close popup
			*/
			popup.close();

			/*
			Refresh
			*/
			window.location.reload();

		})
		.always(function() {
		});

	};

	/*
	New password *************************
	New password *************************
	New password *************************
	New password *************************
	*/
	this.password = function(
	) {

		var _user_id 				= $('.js-user-id').val();
		var _user_username 			= $('.js-user-username').val();
		var _user_firstname 		= $('.js-user-firstname').val();
		var _user_emailaddress 		= $('.js-user-emailaddress').val();

		/*
		Ajax
		*/
		$.ajax({
			url: globalUrl + '/a/a/user-password',
			type: "POST",
			data: {
				user_id 			: _user_id,
				user_username		: _user_username,
				user_firstname 		: _user_firstname,
				user_emailaddress 	: _user_emailaddress,
			},
			headers: { 
				'go-load':1 
			}
		})
		.done(function(data) {

			/*
			Notification
			*/
			notifier.show(
				'Nieuwe gegevens verzonden'
			);

			/*
			Close popup
			*/
			popup.close();

		})
		.always(function() {
		});

	};
		
}).apply(specific_user); 